import { collapsibleOpenStateMapping as baseMapping } from '../../utils/collapsibleOpenStateMapping.js';
import { transitionStatusMapping } from '../../utils/styleHookMapping.js';
export const accordionStyleHookMapping = {
  ...baseMapping,
  index: value => {
    return Number.isInteger(value) ? {
      'data-index': String(value)
    } : null;
  },
  ...transitionStatusMapping,
  value: () => null
};